import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';
import TableComponent from '../../../components/DataTable/TableComponent';
import { encryptLocalStorage } from '../../../utils/localStorage.utils';
import { SELECTED_META_ACCOUNT } from '../../../statics/localStorage';

const MetaAccountsModal = ({ setSelectedMetaAccount }) => {
    const [show, setShow] = useState(false);
    const [tableData, setTableData] = useState([]);
    const metaAccount = SELECTED_META_ACCOUNT();

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => { setShow(true) };

    async function updateMetaCredential() {
        let postData = {
            "metaAdsAccountId": document.getElementById('meta-ad-account-id').value?.trim(),
            "metaAdsAccessToken": document.getElementById('meta-ad-access-token').value?.trim(),
            "accountName": document.getElementById('meta-ad-account-name').value?.trim()
        }
        if (!postData?.metaAdsAccountId || !postData?.metaAdsAccessToken || !postData?.accountName) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.updateMetaAdsCredentials);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.metaAccountList);
        loadingHide();
        handleShow();
        if (resp?.responseCode == 200) {
            setTableData(resp?.data);
        } else {
            setTableData([])
        }
    }

    function onSelectAccount(accountData) {
        encryptLocalStorage('meta-account', accountData);
        setSelectedMetaAccount(accountData)
        handleClose()
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '40px', selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Name", center: "true", selector: (row) => row?.accountName, grow: 0.2, cell: (row) => (
                <p className="mb-0">{row?.accountName || "--"}</p>
            )
        }, {
            name: "Meta Ads Account ID", center: "true", selector: (row) => row?.metaAdsAccountId, grow: 0.3, cell: (row) => (
                <p className="mb-0">{row?.metaAdsAccountId ?? "--"}</p>
            )
        }, {
            name: "Meta Ads Account Token", center: "true", selector: (row) => row?.metaAdsAccountId, grow: 0.5, cell: (row) => (
                <p className="mb-0 max-line-1">{row?.metaAdsAccessToken ?? "--"}</p>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.action, grow: 0.1, cell: (row) => (
                <button className="mb-0 !border !px-2 !py-1 rounded disabled:border-none disabled:text-gray-500" onClick={() => onSelectAccount(row)} disabled={row?.metaAdsAccountId == metaAccount?.metaAdsAccountId}>{row?.metaAdsAccountId == metaAccount?.metaAdsAccountId ? "Selected" : "Select"}</button>
            )
        }]

    return (
        <>
            <button className='mb-0 text-xs font-light text-orange-600 italic !border rounded-lg border-orange-600 !px-3 !py-1 h-max' onClick={() => getList()}>Accounts</button>
            <Modal show={show} onHide={handleClose} size='xl' backdrop="static" >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Your Meta Ads Accounts</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='pb-4'>

                        {accessCheck(accessKeys?.setMetaCredentials) && <div className='bg-white px-3 pt-2 pb-3 !mb-4 rounded-lg'>
                            <label htmlFor="" className='text-md font-semibold mb-2.5'>Meta Credential</label>
                            <div className="grid grid-cols-1 md:grid-cols-2 !gap-3 mb-1">
                                <div className="!mb-1">
                                    <label htmlFor="meta-ad-account-name" className='text-sm  mb-1.5'>Ad Account Name*</label>
                                    <input type="text" id="meta-ad-account-name" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Meta Ad Account a Name" defaultValue={tableData?.length > 0 ? ("Account-" + (tableData?.length + 1)) : "Account-1"} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="meta-ad-account-id" className='text-sm  mb-1.5'>Meta Ad Account ID*</label>
                                    <input type="text" id="meta-ad-account-id" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your Meta Ad Account ID" />
                                </div>
                                <div className="mb-3 col-span-2">
                                    <label htmlFor="meta-ad-access-token" className='text-sm  mb-1.5'>Meta Ad Access Token*</label>
                                    <input type="text" id="meta-ad-access-token" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your Meta Access Token" />
                                </div>
                            </div>
                            <div className='mb-0 flex justify-end'>
                                <button className='text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full' onClick={() => updateMetaCredential()}>Add New</button>
                            </div>
                        </div>}

                        <TableComponent
                            columns={columns}
                            data={tableData}
                            isHeader={true}
                            totalRows={tableData?.length}
                            isPagination={false}
                            paginationPerPage={50}
                            handlePageChange={(e) => { }}
                            handlePerRowsChange={(newPerPage, page) => { }} />

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MetaAccountsModal